<template>
    <div>
        <h1 class="overskrift">Bordadmin</h1>

        <p class="is-size-4 is-size-5-mobile">Kommer snart. En modul for å administrere bordreservasjoner som gjestene selv kan gjøre online.</p>
            
    </div>

</template>

<script>
    export default {
        name: "Bordadmin"
    }
</script>